import { useNavigate } from "react-router";
import { TieredMenu } from 'primereact/tieredmenu';
const Accesscontrol = ({children}) =>{
    const navigate = useNavigate(); 
    const items = [
        {   
            label: <b>Access Control</b>,
        },
        {   
            label: 'Create role',
            icon: 'fa fa-angle-right',
            command: () => {
                navigate('/accesscontrol/createrole');
                // url: '/accesscontrol/createrole',  
            },
        },
        {
            label: 'Create Permisson',
            icon: 'fa fa-angle-right',
            command: () => {
                navigate('/accesscontrol/createpermisson'); 
            }
        },

        {
            label: 'Assign role',
            icon: 'fa fa-angle-right',
            command: () => {
                navigate('/accesscontrol/assignrole'); 
            }
        },
        {
            label: 'Assign Role',
            icon: 'fa fa-angle-right',
            items: [
                {
                    label: 'React.js',
                    url: 'https://react.dev/'
                },
                {
                    label: 'Vite.js',
                    url: 'https://vitejs.dev/'
                }
            ]
        }
    ];
     return (<>
         <div className='row'>
            <div className='col-md-2'><TieredMenu className="internalmenu" model={items} breakpoint="767px" /></div>
            <div className='col-md-10'>{children}</div>
         </div>
     </>);   
} 

export default Accesscontrol; 